import {
  collection,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  getDocs,
  serverTimestamp,
  deleteDoc,
} from 'firebase/firestore';
import { getFirestoreInstance } from './firestore';
import type { Venue } from '@gigdriver/domain';
import { fromFirestore } from './serde';

function venuesCollection(orgId: string) {
  return collection(getFirestoreInstance(), 'organizations', orgId, 'venues');
}

export async function createVenue(
  orgId: string,
  venue: Omit<Venue, 'id' | 'orgId' | 'createdAt' | 'updatedAt'>,
): Promise<string> {
  const venueRef = doc(venuesCollection(orgId));
  const venueId = venueRef.id;

  await setDoc(venueRef, {
    ...venue,
    id: venueId,
    orgId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  return venueId;
}

export async function getVenue(orgId: string, venueId: string): Promise<Venue | null> {
  const venueRef = doc(getFirestoreInstance(), 'organizations', orgId, 'venues', venueId);
  const docSnap = await getDoc(venueRef);
  return docSnap.exists() ? fromFirestore<Venue>(docSnap.data()) : null;
}

export async function getOrgVenues(orgId: string): Promise<Venue[]> {
  const snapshot = await getDocs(venuesCollection(orgId));
  return snapshot.docs.map(d => fromFirestore<Venue>(d.data()));
}

export async function updateVenue(orgId: string, venueId: string, updates: Partial<Venue>): Promise<void> {
  const venueRef = doc(getFirestoreInstance(), 'organizations', orgId, 'venues', venueId);
  await updateDoc(venueRef, {
    ...updates,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteVenue(orgId: string, venueId: string): Promise<void> {
  const venueRef = doc(getFirestoreInstance(), 'organizations', orgId, 'venues', venueId);
  await deleteDoc(venueRef);
}
